import React, { useContext } from "react";
import { CommandBarButton } from "sprint-common-web";

import { FileRecordListingContext } from "../../context/FileRecordListingContext";

export const ClearSelectedFileRecordsButton: React.VFC = () => {
    const { selectedItems, setSelectedItems } = useContext(FileRecordListingContext);

    const clear = () => {
        setSelectedItems([]);
    };

    if (!selectedItems.length) return <></>;

    return <CommandBarButton icon="Cancel" onClick={clear} text={`${selectedItems.length} selected`} />;
};
